module.exports = __webpack_public_path__ + "img/0Q3B2213_L_WoodMatted_MockedUp.1ca0ac8d.jpg";